export default __webpack_public_path__ + "static/media/Photo 1 - BR - ouverture Nord.833bb61d.png";